class AjaxRequest {
    constructor(options) {
        var _this = this;
        this.elementToAddLoading = null;
        this.requestType = 'post';

        this.errorCallback = function () { };
        this.successCallback = function () { };

        this.beforeSend = function () {
            _this._toggleLoadingClass(true);
        };

        this.complete = function () {
            _this._toggleLoadingClass(false);
        };

        if (typeof options !== 'undefined') {
            Object.assign(_this, options);
        }
    }

    _resolveElements() {
        if (this.elementToAddLoading === null) {
            return [];
        }

        if (typeof this.elementToAddLoading === "string") {
            return document.querySelectorAll(this.elementToAddLoading);
        }

        if (this.elementToAddLoading instanceof Element) {
            return [this.elementToAddLoading];
        }

        return this.elementToAddLoading;
    }

    _toggleLoadingClass(isLoading) {
        var elements = this._resolveElements();

        elements.forEach ? elements.forEach(function (el) {
            el.classList.toggle("is-loading", isLoading);
        }) : Array.prototype.forEach.call(elements, function (el) {
            el.classList.toggle("is-loading", isLoading);
        });
    }

    makeCall(url, params, options) {
        var _this = this;

        options = Object.assign({
            type: _this.requestType,
            url: url,
            data: params,
            beforeSend: _this.beforeSend,
            complete: _this.complete,
            success: _this.successCallback,
            error: _this.errorCallback
        }, options);

        var method = (options.type || 'post').toUpperCase();
        var requestUrl = options.url;
        var fetchOptions = {
            method: method,
            headers: {}
        };

        var data = options.data;

        if (data !== undefined && data !== null) {
            if (method === 'GET') {
                var queryString = new URLSearchParams(data).toString();
                if (queryString) {
                    requestUrl += (requestUrl.indexOf('?') === -1 ? '?' : '&') + queryString;
                }
            } else {
                fetchOptions.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
                fetchOptions.body = new URLSearchParams(data).toString();
            }
        }

        if (typeof options.beforeSend === 'function') {
            options.beforeSend();
        }

        fetch(requestUrl, fetchOptions)
            .then(function (response) {
                var contentType = response.headers.get('content-type') || '';

                if (!response.ok) {
                    return response.text().then(function (text) {
                        var error = new Error('Request failed with status ' + response.status);
                        error.response = response;
                        error.body = text;
                        throw error;
                    });
                }

                if (contentType.indexOf('application/json') !== -1) {
                    return response.json();
                }

                return response.text();
            })
            .then(function (responseData) {
                if (typeof options.success === 'function') {
                    options.success(responseData);
                }
            })
            .catch(function (error) {
                if (typeof options.error === 'function') {
                    options.error(error);
                }
            })
            .finally(function () {
                if (typeof options.complete === 'function') {
                    options.complete();
                }
            });
    }
}

export default AjaxRequest